import React from 'react';
import { MediaItem } from "./media-api";


export function MediaType({media}:{media:MediaItem}){
    if(media.mimetype.startsWith("audio")) return <><i className='fa fa-volume-high'></i> Audio</>
    if(media.mimetype.startsWith("image")) return <><i className='far fa-image'></i> Imagem</>
    if(media.mimetype.startsWith("video")) return <><i className='far fa-circle-play'></i> Vídeo</>
    return <><i className='far fa-file'></i> Anexo</>
}